/* Preview gift: local persistent timers and native Shopify discount codes.
   Timers govern this page/cart only; an already opened checkout is not revoked. */
(() => {
  'use strict';
  const configEl = document.getElementById('sfhg-config');
  if (!configEl || window.SofthourHalloween) return;
  const cfg = JSON.parse(configEl.textContent);
  const priceTest = window.SofthourPriceAB;
  if (priceTest?.renderedProductId) cfg.productId = priceTest.renderedProductId;
  const basePrice = 7499; // Winning offer is now native on both promotional products.
  const candyShipping = 999; // Existing US tier for a $69.99 subtotal.
  const fleeceProduct = pid => ['10195007799351','15417171902519'].includes(String(pid));
  document.querySelectorAll('[data-sfhg-reward-price]').forEach(el => {el.textContent = '$' + ((basePrice - 500) / 100).toFixed(2);});
  const ab = window.SofthourHalloweenAB;
  if (!cfg.officialMode && ab?.enroll) cfg.abMode = true;
  if (!cfg.officialMode && cfg.abMode && (!ab || ab.a.variant !== 'B')) return;
  // Keep existing live Candy deadlines when promoting B; ignore old A/B assignments.
  const KEY = cfg.officialMode ? 'sfhg:softhour-halloween-20261012-v1:live' : cfg.abMode ? 'sfhg:'+ab.exp+(ab.qa?':qa:B':':live') : 'sfhg:20261012-preview-v2';
  const text = (key, fallback) => typeof cfg.text?.[key] === 'string' ? cfg.text[key] : fallback;
  const money = n => new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'}).format(n / 100);
  const root = window.Shopify?.routes?.root || '/';
  const readSaved = value => {
    try {
      const d = JSON.parse(value || 'null');
      return d?.version === 2 && ['claim','cart','expired'].includes(d.state) &&
        Number.isFinite(d.addDeadline) && (d.cartDeadline === null || Number.isFinite(d.cartDeadline)) ? d : null;
    } catch (_) { return null; }
  };
  let saved = null;
  try { saved = readSaved(localStorage.getItem(KEY)); } catch (_) {}
  const inPage = (cfg.officialMode || cfg.abMode) ? !!document.querySelector('product-form-component[data-product-id="'+cfg.productId+'"]') : cfg.page === 'promo-halloween';
  if (cfg.currency !== 'USD' || (!inPage && !saved) || !cfg.code5 || !cfg.code25) return;
  const launcher = document.querySelector('[data-sfhg-launcher]'), dialog = document.querySelector('[data-sfhg-dialog]');
  const urlReset = cfg.previewReset && new URLSearchParams(location.search).get('candy') === 'reset';
  let launcherReady = false;
  let nativeApplied = false, confirmedCheckoutCode = null, uiUnavailable = false, cartNeedsRecovery = false, expiredCleaned = false;
  let syncPromise = null, preparePromise = null, resetPromise = null, queue = false, resetting = false, cartDelay;
  let refreshCartSections = false;
  const write = () => {try {localStorage.setItem(KEY, JSON.stringify(saved));} catch (_) {}};
  const deadline = () => Number(saved?.cartDeadline ?? saved?.addDeadline ?? 0);
  const eligible = () => !!saved && ['claim','cart'].includes(saved.state) && deadline() > Date.now();
  const active = () => eligible() && !uiUnavailable;
  const clock = () => {
    const s = Math.max(0, Math.ceil((deadline() - Date.now()) / 1000));
    return String(Math.floor(s / 60)).padStart(2,'0') + ':' + String(s % 60).padStart(2,'0');
  };
  function expire() {
    if (saved && saved.state !== 'expired' && deadline() <= Date.now()) {
      saved.state = 'expired'; write(); return true;
    }
    return false;
  }
  function notice(text) {
    let el = document.querySelector('.sfhg-status');
    if (!el) {el = document.createElement('div');el.className = 'sfhg-status';el.setAttribute('role','status');document.body.append(el);}
    el.textContent = text;clearTimeout(el._hide);el._hide = setTimeout(() => el.remove(),6500);
  }
  async function jsonFetch(url, options = {}) {
    const r = await fetch(url,{...options,signal:options.signal || AbortSignal.timeout(3500),headers:{Accept:'application/json',...(options.body ? {'Content-Type':'application/json'} : {}),...options.headers}});
    const d = await r.json();if (!r.ok) throw Error('cart_unavailable');return d;
  }
  const cartGet = signal => jsonFetch(root + 'cart.js',{signal});
  const shape = (cart,add = 0,flash = false) => ({
    quantity:cart.items.filter(x => fleeceProduct(x.product_id)).reduce((n,x) => n + x.quantity,0) + add,
    flashUpsell:flash || cart.items.some(x => fleeceProduct(x.product_id) && x.properties?._cv_flash),
  });
  const codesOf = cart => Array.isArray(cart.discount_codes) ? cart.discount_codes.map(x => x.code).filter(Boolean) :
    [...new Set([...(cart.cart_level_discount_applications || []),...cart.items.flatMap(i => (i.line_level_discount_allocations || []).map(a => a.discount_application))]
      .filter(x => x?.type === 'discount_code').map(x => x.title).filter(Boolean))];
  const sameCode = (a,b) => String(a).toUpperCase() === String(b).toUpperCase();
  const ownCode = code => sameCode(code,cfg.code5) || sameCode(code,cfg.code25);
  const flashCode = code => sameCode(code,'FLASH-FLEECE20');
  const selection = s => s.quantity >= 2 && s.flashUpsell ? {code:cfg.code25,amount:2500} : {code:cfg.code5,amount:500};
  const sections = () => [...new Set([...document.querySelectorAll('cart-items-component')].map(x => x.dataset.sectionId).filter(Boolean))];
  const discountTotal = (cart,match) => cart.items.filter(i => fleeceProduct(i.product_id)).reduce((sum,i) => sum +
    (i.line_level_discount_allocations || []).filter(a => match(a.discount_application?.title || '')).reduce((n,a) => n + Number(a.amount || 0),0),0);
  const applied = (cart,amount) => discountTotal(cart,t => ownCode(t) || (cfg.title5 && sameCode(t,cfg.title5)) || (cfg.title25 && sameCode(t,cfg.title25))) === amount;
  function dispatchCart(cart) {
    const event = new Event('cart:update',{bubbles:true});event.detail = {resource:cart,sourceId:'sf-halloween-gift',data:{sections:cart.sections}};document.dispatchEvent(event);
  }
  async function setCode(cart,code,signal,refreshSections = false) {
    let codes = codesOf(cart).filter(c => !ownCode(c));
    if (code) {codes = codes.filter(c => !flashCode(c));codes.push(code);}
    else {const s = shape(cart);if (s.quantity >= 2 && s.flashUpsell && !codes.some(flashCode)) codes.push('FLASH-FLEECE20');}
    const selected = [...new Set(codes)], normalize = list => list.map(c => c.toUpperCase()).sort().join(',');
    if (!refreshSections && normalize(selected) === normalize(codesOf(cart))) return cart;
    const result = await jsonFetch(root + 'cart/update.js',{method:'POST',signal,body:JSON.stringify({discount:selected.join(','),sections:sections(),sections_url:location.pathname + location.search})});
    dispatchCart(result);return result;
  }
  async function restoreNativeOffer() {
    const signal = AbortSignal.timeout(3500);
    const refresh = refreshCartSections;refreshCartSections = false;
    let cart = await cartGet(signal);cart = await setCode(cart,null,signal,refresh);
    const s = shape(cart);
    if (s.quantity >= 2 && s.flashUpsell && discountTotal(cart,t => /flash/i.test(t)) < 2000) throw Error('native_upsell_unconfirmed');
    nativeApplied = false;confirmedCheckoutCode = null;uiUnavailable = true;render();return cart;
  }
  function restorePrice() {
    document.querySelectorAll('[data-sfhg-base]').forEach(p => {
      const base = Number(p.dataset.sfhgBase);p.querySelectorAll('.price-item--sale').forEach(x => x.textContent = money(base) + ' USD');
      p.classList.remove('sfhg-active-price');p.querySelector('.sfhg-price-note')?.remove();p.querySelector('.sfhg-gift-badge')?.remove();
      const s = p.querySelector('.sf-offer-badge--saving');if (s) s.textContent = 'SAVE ' + money(Number(p.dataset.sfhgCompare) - base);
    });
  }
  function renderCartNote() {
    if (!active() || saved.state !== 'cart' || !nativeApplied) {
      document.querySelectorAll('.sfhg-cart-note').forEach(x => x.remove());return;
    }
    document.querySelectorAll('.cart-drawer__summary,.cart__summary').forEach(p => {
      if (!p.querySelector('.sfhg-cart-note')) {
        const n = document.createElement('div');n.className = 'sfhg-cart-note';
        n.innerHTML = '<p><b></b><small></small></p><strong data-sfhg-clock></strong>';
        n.querySelector('b').textContent = text('cart_title','Your Halloween treat is secured');
        n.querySelector('small').textContent = text('cart_subtitle','Use your treat before it expires in…');
        const c = p.querySelector('[name="checkout"]');if (c) c.parentElement.insertBefore(n,c);else p.append(n);
      }
    });
  }
  function updateClocks() {
    const value = clock();
    document.querySelectorAll('[data-sfhg-clock]').forEach(x => {if (x.textContent !== value) x.textContent = value;});
  }
  function render() {
    if (launcher) launcher.hidden = !launcherReady || !!saved || !inPage || resetting;
    const showOffer = active() && (saved.state !== 'cart' || nativeApplied);
    if (!showOffer) {
      restorePrice();renderCartNote();
      if (dialog?.open) {dialog.querySelector('[data-sfhg-success]').hidden = true;const e = dialog.querySelector('[data-sfhg-error]');e.hidden = false;
        e.textContent = saved?.state === 'expired' ? text('expired_text','Your Halloween cart offer has ended. The Halloween Sale is still available.') : 'Your gift could not be confirmed. Please check the price in your bag.';}
      return;
    }
    document.querySelectorAll('[data-sfhg-base]').forEach(p => {
      const base = Number(p.dataset.sfhgBase);if (base !== basePrice) return;
      p.classList.add('sfhg-active-price');p.querySelectorAll('.price-item--sale').forEach(x => x.textContent = money(base - 500) + ' USD');
      let note = p.querySelector('.sfhg-price-note');if (!note) {note = document.createElement('div');note.className = 'sfhg-price-note';note.innerHTML = '<span><span data-sfhg-price-title></span><small></small></span><strong data-sfhg-clock></strong>';
        note.querySelector('[data-sfhg-price-title]').textContent = text('price_title','Your $5 Halloween gift');p.append(note);}
      note.querySelector('small').textContent = saved.state === 'cart' ? text('after_add','Complete your order in…') : text('before_add','Add to your bag while this offer is on screen');
      if (cfg.country === 'US') note.querySelector('small').textContent += ' · One fleece: ' + money(candyShipping) + ' US shipping, ' + money(basePrice - 500 + candyShipping) + ' before tax';
      if (!p.querySelector('.sfhg-gift-badge')) {const b = document.createElement('span');b.className = 'sfhg-gift-badge';b.textContent = '🎃 EXTRA $5 GIFT';p.querySelector('.sf-offer-badges')?.append(b);}
      const s = p.querySelector('.sf-offer-badge--saving');if (s) s.textContent = 'SAVE ' + money(Number(p.dataset.sfhgCompare) - base + 500);
    });
    renderCartNote();updateClocks();
  }
  function tick() {
    if (resetting) return;
    if (expire()) {render();notice(text('expired_text','Your Halloween cart offer has ended. The Halloween Sale is still available.'));}
    // Native section rendering may complete after our cart:update handler and
    // erase the inserted note. Repair the DOM, never the persisted deadline.
    renderCartNote();updateClocks();
    if (saved?.state === 'expired' && !expiredCleaned && !syncPromise) sync().catch(() => {});
  }
  async function sync(refreshSections = false) {
    if (resetting || !saved) return false;
    refreshCartSections = refreshCartSections || refreshSections;
    if (syncPromise) {queue = true;return syncPromise;}
    syncPromise = (async () => {
      let safe = false;
      do {
        queue = false;safe = false;
        try {
          if (preparePromise) await preparePromise;
          expire();
          if (!eligible()) {await restoreNativeOffer();expiredCleaned = true;safe = true;continue;}
          let cart = await cartGet();const s = shape(cart), offer = selection(s);
          const refresh = refreshCartSections;refreshCartSections = false;
          cart = await setCode(cart,offer.code,undefined,refresh);nativeApplied = applied(cart,offer.amount);uiUnavailable = false;
          confirmedCheckoutCode = nativeApplied ? offer.code : null;
          if (s.quantity > 0 && !nativeApplied) {
            await restoreNativeOffer();notice('Your gift could not be applied. Your usual offer is still available; check your bag total.');
          }
          render();safe = true;
        } catch (_) {
          nativeApplied = false;confirmedCheckoutCode = null;uiUnavailable = true;render();
          try {await restoreNativeOffer();safe = true;if (!eligible()) expiredCleaned = true;notice('Your gift could not be confirmed. Your usual offer is still available; check your bag total.');}
          catch (_) {notice('We could not confirm your bag total. Please try again before checkout.');}
        }
      } while (queue && !resetting);
      cartNeedsRecovery = !safe;return safe;
    })();
    try {return await syncPromise;} finally {syncPromise = null;}
  }
  async function prepare(add = 1,flash = false) {
    if (resetting || !eligible()) return false;
    if (syncPromise) await syncPromise;
    if (preparePromise) await preparePromise;
    if (resetting || !eligible()) return false;
    preparePromise = (async () => {
      try {
        const signal = AbortSignal.timeout(3500), cart = await cartGet(signal);
        const offer = selection(shape(cart,add,flash));await setCode(cart,offer.code,signal);return true;
      } catch (_) {uiUnavailable = true;render();notice('We could not apply your gift right now. Please check the price in your bag.');return false;}
    })();
    try {return await preparePromise;} finally {preparePromise = null;}
  }
  function claim() {
    if (resetting) return;
    if (!saved) {const at = Date.now();saved = {version:2,state:'claim',claimedAt:at,addDeadline:at + 120000,cartDeadline:null};write();}
    expire();uiUnavailable = false;render();
  }
  window.SofthourHalloween = {
    prepareAdd:async (pid,formData) => fleeceProduct(pid) ? prepare(Number(formData.get('quantity') || 1),false) : false,
    prepareUpsell:pid => fleeceProduct(pid) ? prepare(1,true) : Promise.resolve(false),active,
  };
  document.querySelector('[data-sfhg-open]')?.addEventListener('click',() => {
    if (resetting) return;
    claim();dialog.showModal();dialog.querySelector('[data-sfhg-loading]').hidden = true;
    dialog.querySelector('[data-sfhg-error]').hidden = active();dialog.querySelector('[data-sfhg-success]').hidden = !active();
    render();
    // Prepare the native cart after the user claims; the reveal never waits on a request.
    if (eligible()) sync().catch(() => {});
  });
  document.querySelectorAll('[data-sfhg-close]').forEach(x => x.addEventListener('click',() => dialog.close()));
  async function resetGift() {
    if (!cfg.previewReset || resetting) return;
    resetting = true;clearTimeout(cartDelay);render();
    resetPromise = (async () => {
      try {
        if (preparePromise) await preparePromise;
        if (syncPromise) await syncPromise;
        await restoreNativeOffer();localStorage.removeItem(KEY);saved = null;
        // Consume only the reset command so refreshes do not reset the timer again.
        // Keep preview access, attribution parameters and the current anchor intact.
        const params = new URLSearchParams(location.search);params.delete('candy');
        const search = params.toString();
        history.replaceState(history.state,'',location.pathname + (search ? '?' + search : '') + location.hash);
        location.reload();
      } catch (_) {resetting = false;render();notice('Impossible de confirmer le panier. Rechargez cette page pour réessayer la réinitialisation.');}
    })();
    try {await resetPromise;} finally {resetPromise = null;}
  }
  dialog?.addEventListener('click',e => {if (e.target === dialog) {const r = dialog.getBoundingClientRect();if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();}});
  document.addEventListener('variant:update',() => requestAnimationFrame(render));
  document.addEventListener('cart:update',e => {
    if (resetting || e.detail?.sourceId === 'sf-halloween-gift') {render();return;}
    const d = e.detail?.data || {}, added = !d.didError && fleeceProduct(d.productId) && Array.isArray(d.addedItems) && d.addedItems.length > 0;
    // Commit immediately on the actual successful ATC, before any request or reload.
    if (added && eligible() && saved.state === 'claim') {saved.state = 'cart';saved.cartDeadline = Date.now() + 300000;write();}
    render();if (!saved) return;
    clearTimeout(cartDelay);cartDelay = setTimeout(() => sync(),added ? 0 : 180);
  });
  let checkoutBusy = false, checkoutReady = false;
  const checkoutSelector = 'button[name="checkout"],a[href="/checkout"],#checkout';
  async function checkout(e,b) {
    if (!b || !saved || resetting || checkoutReady || (!cartNeedsRecovery && !syncPromise && !preparePromise && !eligible() && expiredCleaned)) return;
    e.preventDefault();e.stopImmediatePropagation();if (checkoutBusy) return;checkoutBusy = true;b.setAttribute('aria-busy','true');
    const expectedGift = active();
    let safe = false;
    try {clearTimeout(cartDelay);safe = await sync();} finally {checkoutBusy = false;b.removeAttribute('aria-busy');}
    if (!safe) {notice('We could not confirm your bag total. Please try again before checkout.');return;}
    // A successful fallback confirms the ordinary price, not the promised gift.
    // Leave the updated total visible before the customer decides to continue.
    if (expectedGift && (!eligible() || !nativeApplied || !confirmedCheckoutCode)) {
      notice('Your Halloween gift could not be confirmed. Please review your updated bag total, then try checkout again.');return;
    }
    if (eligible() && nativeApplied && confirmedCheckoutCode) {
      // Explicitly hand the confirmed code to Shopify's server-side discount
      // route. A normal /cart submit can resume an older checkout without it.
      (window.SofthourPriceAB || window.SofthourHalloweenAB)?.checkout?.();
      location.assign(root + 'discount/' + encodeURIComponent(confirmedCheckoutCode) + '?redirect=' + encodeURIComponent(root + 'checkout'));
      return;
    }
    const currentButton = b.isConnected ? b : document.querySelector(checkoutSelector);checkoutReady = true;
    try {if (currentButton) currentButton.click();else {(window.SofthourPriceAB || window.SofthourHalloweenAB)?.checkout?.();location.assign(root + 'checkout');}} finally {checkoutReady = false;}
  }
  document.addEventListener('click',e => checkout(e,e.target.closest?.(checkoutSelector)),true);
  document.addEventListener('submit',e => checkout(e,e.submitter?.matches?.(checkoutSelector) ? e.submitter : null),true);
  document.addEventListener('visibilitychange',() => {if (!document.hidden && saved) sync();});
  window.addEventListener('pageshow',e => {
    if (!e.persisted) return;
    // Back/Forward can restore pre-gift HTML and a stale in-memory claim.
    try {saved = readSaved(localStorage.getItem(KEY));} catch (_) {}
    if (saved) sync(true);
  });
  window.addEventListener('storage',e => {
    if (e.key !== KEY) return;
    saved = readSaved(e.newValue);nativeApplied = false;confirmedCheckoutCode = null;uiUnavailable = false;expiredCleaned = false;render();
    if (saved) sync();else restoreNativeOffer().catch(() => notice('Please check your bag total before checkout.'));
  });
  if (typeof MutationObserver === 'function') {
    const cartStructure = '.cart-drawer__summary,.cart__summary,.sfhg-cart-note';
    const observer = new MutationObserver(records => {
      if (resetting || !active() || saved.state !== 'cart' || !nativeApplied) return;
      const replaced = records.some(r => [...r.addedNodes,...r.removedNodes].some(n =>
        n.nodeType === 1 && (n.matches?.(cartStructure) || n.querySelector?.(cartStructure))));
      if (replaced) {renderCartNote();updateClocks();}
    });
    document.querySelectorAll('cart-drawer-component,main').forEach(root => observer.observe(root,{childList:true,subtree:true}));
  }
  setInterval(tick,1000);render();
  if (launcher && inPage && !saved && !urlReset) {
    setTimeout(() => {launcherReady = true;render();},2500);
  }
  if (urlReset) resetGift();
  else if (saved) sync(true); // Reconcile restored HTML; unclaimed visits make no request.
})();
